export default {
  terms: 'terms',
  cardOption: 'cardOption',
  cardOptionDebit: 'debit',
  cardOptionSaved: 'saved',
  cardOptionPreAuth: 'preAuth',
  cardOptionFunds: 'funds',
};
